import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { CommonDTO } from 'app/model/common-dto';
import { CommonService } from 'app/service/common.service';
import { CustomMessages } from '@shared';
import { ManageAuditProgramDto } from 'app/model/manage-audit-program-dto';
import { PostCommentInput } from 'app/model/post-comment-input-dto';
import { PostCommentResponseBean } from './../../../../model/post-comment-response-bean';

@Component({
  selector: 'app-postcomments',
  templateUrl: './postcomments.component.html',
  styleUrls: ['./postcomments.component.scss'],
})
export class PostcommentsComponent implements OnInit {
  quillConfig = {
    toolbar: [
      ['bold', 'italic', 'underline'], // toggled buttons
      //  ['blockquote', 'code-block'],

      // [{ 'header': 1 }, { 'header': 2 }],               // custom button values
      [{ list: 'ordered' }, { list: 'bullet' }],
      // [{ 'script': 'sub'}, { 'script': 'super' }],      // superscript/subscript
      [{ indent: '-1' }, { indent: '+1' }], // outdent/indent
      // [{ 'direction': 'rtl' }],                         // text direction

      // [{ 'size': ['small', false, 'large', 'huge'] }],  // custom dropdown
      [{ header: [1, 2, 3, 4, 5, 6, false] }],

      // [{ 'color': [] }, { 'background': [] }],          // dropdown with defaults from theme
      // [{ 'font': [] }],
      // [{ 'align': [] }],

      //['clean'],                                         // remove formatting button

      // ['link', 'image', 'video']                         // link and image, video
    ],
  };
  selectedUser: string;
  users: any[] = [];
  ccUsers: any[] = [];
  parsedJson: any;
  userNames = [];
  selectedCCUser: string;
  postCommentCount: string;
  selectedSubject: string;
  selectedBody: string;
  postCommentInput: PostCommentInput = new PostCommentInput();
  postCommentResponseBean: PostCommentResponseBean[];
  noRecordFound: boolean;

  commonDTO: CommonDTO = new CommonDTO();
  @Output() closePanelcomments: EventEmitter<boolean> = new EventEmitter();
  @Input() auditProgramId: string;
  @Input() auditProgramName: string;
  @Input() auditItemId: string;
  @Input() auditItemDescription: string;
  @Input() auditStatusId: string;
  @Input() enableAllTransaction: string;
  @Input() siteId: number;

  @Output() isPostCommented: EventEmitter<string> = new EventEmitter();

  constructor(private commonService: CommonService, private customMessages: CustomMessages) {}

  ngOnInit() {
    // this.userNames.forEach((c, i) => {
    //   this.users.push({ id: i, name: c });
    // });
    this.postCommentInput.auditItemId = this.auditItemId;
    this.postCommentInput.auditProgramId = this.auditProgramId;
    this.users = [];
    this.userNames = [];
    this.getPostCommentList();
    this.getPostCommentCount();
  }
  closed() {
    this.selectedUser = '';
    this.selectedCCUser = '';
    this.selectedBody = '';
    this.selectedSubject = '';

    this.closePanelcomments.emit(false);
  }

  onSearchChange(searchValue: string): void {
    if (searchValue.length > 2) {
      this.commonDTO.searchValue = searchValue;
      this.userList('postTo');
    } else {
      this.users = [];
    }
  }
  onSearchCC(searchValue: string): void {
    if (searchValue.length > 2) {
      this.commonDTO.searchValue = searchValue;
      this.userList('postCC');
    } else {
      this.ccUsers = [];
    }
  }
  userList(type: string) {
    this.commonService.postCommentUserMailComboList(this.commonDTO).subscribe(
      data => {
        this.parsedJson = JSON.parse(JSON.stringify(data));
        if (type == 'postTo') {
          this.users = this.parsedJson;
        } else {
          this.ccUsers = this.parsedJson;
        }
      },
      error => {
        //this.error = error;
        this.customMessages.showErrorMessage(error.error.msgId, error.error.message);
      }
    );
  }
  addComment() {
    if (this.selectedUser == undefined || this.selectedUser == '') {
      this.customMessages.showErrorMessage('cams.label.postComments.mandatoryPostTo', '');
      return false;
    }

    if (this.selectedSubject == undefined || this.selectedSubject == '') {
      this.customMessages.showErrorMessage('cams.label.postComments.mandatorySubject', '');
      return false;
    }
    if (this.selectedBody == undefined || this.selectedBody == '') {
      this.customMessages.showErrorMessage('cams.label.postComments.mandatoryMailBody', '');
      return false;
    }
    if (this.auditStatusId == '256') {
      this.customMessages.showErrorMessage(
        'cams.label.common.operationDeclinedClosedAuditProgram',
        ''
      );
      return false;
    }

    this.postCommentInput.postTo = this.selectedUser
      .toString()
      .split(',')
      .join(';');

    if (this.selectedCCUser != undefined) {
      this.postCommentInput.postCC = this.selectedCCUser
        .toString()
        .split(',')
        .join(';');
    } else {
      this.postCommentInput.postCC = '';
    }
    this.postCommentInput.subject = this.selectedSubject;
    this.postCommentInput.bodyHtmlText = this.selectedBody;
    this.postCommentInput.bodyPlainText = this.selectedBody.replace(/<[^>]*>/g, '');
    this.postCommentInput.siteId = this.siteId;
    this.postCommentInput.auditItemId = this.auditItemId;
    this.commonService.addPostComment(this.postCommentInput).subscribe(
      (data: any) => {
        this.customMessages.showSuccessMessage(2);
        this.getPostCommentList();
        this.getPostCommentCount();
        this.selectedUser = '';
        this.selectedCCUser = '';
        this.selectedBody = '';

        this.parsedJson = JSON.parse(JSON.stringify(data));
        if (data.result == '1') {
          this.customMessages.showSuccessMessage(
            'cams.label.common.operationCompletedSuccessfully'
          );
          this.selectedSubject = '';
        }
      },
      error => {
        this.customMessages.showErrorMessage(error.error.msgId, error.error.message);
      }
    );
  }
  getPostCommentList() {
    this.commonService.getPostCommentList(this.postCommentInput).subscribe(
      data => {
        this.parsedJson = JSON.parse(JSON.stringify(data));

        this.postCommentResponseBean = this.parsedJson;
        if (this.parsedJson.length > 0) {
          //this.selectedSubject = this.postCommentResponseBean[0].subject;
          this.noRecordFound = false;
          //Added on 6-nov-24 -- include audit name and scope name in mail subject -- start
          if (this.auditProgramName != undefined && this.auditItemDescription != undefined) {
            this.selectedSubject =
              'RE: ' +
              this.auditProgramName.trim().substring(0, 100) +
              ' => ' +
              this.auditItemDescription.trim().substring(0, 200);
          } else if (this.auditProgramName != undefined && this.auditItemDescription == undefined) {
            this.selectedSubject = 'RE: ' + this.auditProgramName.trim().substring(0, 100);
          } else if (this.auditProgramName == undefined && this.auditItemDescription != undefined) {
            this.selectedSubject = 'RE: ' + this.auditItemDescription.trim().substring(0, 200);
          }
          //Added on 6-nov-24 -- include audit name and scope name in mail subject -- end
        } else {
          //Added on 6-nov-24 -- include audit name and scope name in mail subject -- start
          if (this.auditProgramName != undefined && this.auditItemDescription != undefined) {
            this.selectedSubject =
              this.auditProgramName.trim().substring(0, 100) +
              ' => ' +
              this.auditItemDescription.trim().substring(0, 200);
          } else if (this.auditProgramName != undefined && this.auditItemDescription == undefined) {
            this.selectedSubject = this.auditProgramName.trim().substring(0, 100);
          } else if (this.auditProgramName == undefined && this.auditItemDescription != undefined) {
            this.selectedSubject = this.auditItemDescription.trim().substring(0, 200);
          }
          //Added on 6-nov-24 -- include audit name and scope name in mail subject -- end
        }
        {
          this.noRecordFound = true;
        }
      },
      error => {
        //this.error = error;
        this.customMessages.showErrorMessage(error.error.msgId, error.error.message);
      }
    );
  }

  getPostCommentCount() {
    this.commonService.getPostCommentCount(this.postCommentInput).subscribe(
      data => {
        this.parsedJson = JSON.parse(JSON.stringify(data));

        this.postCommentCount = this.parsedJson.count;
        this.isPostCommented.emit(this.postCommentCount);
      },
      error => {
        //this.error = error;
        this.customMessages.showErrorMessage(error.error.msgId, error.error.message);
      }
    );
  }
}
